module.exports = __webpack_public_path__ + "img/logo.2cd915df.png";